<div class="work-interval" #workInterval [hidden]="!workInterval"></div>
